import styles from "./ALumniPaymentError.module.css";
import React, { useEffect, useState } from "react";
import {
  createDonationPaymentData,
  submitDonationPayment,
} from "@/services/DonationPaymentService";
import Loader from "@/components/Loader/Loader";
import Image from "next/image";
import Link from "next/link";

const ALumniPaymentError = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [donationDetails, setDonationDetails] = useState<{
    amount: number;
    email: string;
    name: string;
  } | null>(null);

  useEffect(() => {
    const storedDetails = localStorage.getItem("donationDetails");
    if (storedDetails) {
      setDonationDetails(JSON.parse(storedDetails));
    }
  }, []);

  const handleRetry = async () => {
    if (!donationDetails) {
      console.error("No donation details found");
      return;
    }

    setIsLoading(true);
    try {
      const paymentData = await createDonationPaymentData(
        donationDetails.amount,
        donationDetails.email,
        donationDetails.name
      );

      await submitDonationPayment(paymentData);
    } catch (error) {
      console.error("Error retrying payment:", error);
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className={styles.PaymentSuccessPage}>
      <div className={styles.container}>
        <div className={styles.card}>
          <div className={styles.iconWrapper}>
            <span className={styles.checkIcon}>
              <Image
                src="/assets/error.png"
                alt="payment"
                title="payment"
                className={styles.logo}
                width={64}
                height={64}
              />
            </span>
          </div>
          <h1 className={styles.title}>Sorry, Payment failed!</h1>
          <p className={styles.subtitle}>
            It looks like your session timed out or your payment couldn’t be
            processed. Don’t worry — you haven’t been charged.
          </p>

          <div>
            {/* {donationDetails && (
              <button
                className={styles.paymentRetryButton}
                onClick={handleRetry}
                disabled={isLoading}
              >
                Retry Payment
              </button>
            )} */}
            <button
              className={styles.paymentRetryButton}
              onClick={handleRetry}
              disabled={isLoading}
            >
              Retry Payment
            </button>

            <p>
              Need help? Contact us at [
              <Link href="mailto:support@regenesys.com">
                support@regenesys.com
              </Link>
              ]
            </p>
            {/* <button
              className={styles.homeButton}
              onClick={() => router.push("/")}
            >
              Return to Home
            </button> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ALumniPaymentError;
